import * as React from "react";

import { SvgIconComponent } from "@mui/icons-material";
import {
  Chip,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import { Paths } from "configs";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { mapModifiers } from "utils";

export interface SidebarMenuItem {
  id: string;
  label: string;
  tooltipTitle?: string;
  path: string;
  icon: SvgIconComponent;
}

export interface SidebarMenu {
  id: string;
  name: string;
  children: Array<SidebarMenuItem>;
}

export interface Props {
  close: boolean;
  version: string;
  menu: Array<SidebarMenu>;
  onClickMenuCallback?: () => void;
}

export const SideBar: React.FC<Props> = ({
  close,
  version,
  menu,
  onClickMenuCallback,
}) => {
  const location = useLocation();

  return (
    <div className={mapModifiers("O-SideBar", close && "Close")}>
      {menu.map(({ id: groupID, name, children }, index) => {
        return (
          <React.Fragment key={groupID}>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                close ? null : (
                  <ListSubheader disableSticky component="div">
                    {name}
                  </ListSubheader>
                )
              }
            >
              {children.map(({ id, label, path, icon, tooltipTitle }) => (
                <ListItemButton
                  key={id}
                  to={path}
                  component={RouterLink}
                  onClick={onClickMenuCallback}
                  className={mapModifiers(
                    "O-SideBar_MenuItem",
                    (path === Paths.General.App
                      ? location.pathname === Paths.General.App
                      : location.pathname.includes(path)) && "Active"
                  )}
                >
                  {close ? (
                    <Tooltip
                      title={tooltipTitle || label}
                      placement="right"
                      arrow
                    >
                      <ListItemIcon>
                        <SvgIcon component={icon} />
                      </ListItemIcon>
                    </Tooltip>
                  ) : (
                    <ListItemIcon>
                      <SvgIcon component={icon} />
                    </ListItemIcon>
                  )}
                  <ListItemText primary={label} />
                </ListItemButton>
              ))}
            </List>
            {!close && index < menu.length - 1 ? <Divider /> : null}
          </React.Fragment>
        );
      })}
      {close ? null : (
        <>
          <Divider />
          <div className="O-SideBar_Version">
            <Chip label={version} size="small" />
          </div>
        </>
      )}
    </div>
  );
};
